import React from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";

const PayPalButton = props => {
    return (
        <div data-testid="paypal-button">
            <PayPalButtons
                style={{
                    color: "black",
                    tagline: false,
                    height: 48
                }}
                fundingSource="paypal"
                {...props}
            />
        </div>
    );
};

export default PayPalButton;
